module.exports = __webpack_public_path__ + "img/CG.ce5581df.png";